/**
 * Dosya uzantısına veya MIME türüne göre dosya türünü otomatik algılar
 *
 * @param {File} file - Analiz edilecek dosya
 * @returns {String|null} - Dosya türü ID'si
 */
export const autoDetectFileType = (file) => {
  if (!file) return null

  if (file.type?.startsWith('image/')) {
    return '6'  // GÖRSEL için ID değeri
  } else if (
      file.type?.includes('presentation') ||
      file.name?.toLowerCase?.().endsWith('.ppt') ||
      file.name?.toLowerCase?.().endsWith('.pptx')
  ) {
    return '2'  // SUNUM için ID değeri
  } else {
    return '1'  // DOSYA için ID değeri
  }
}